import { Reveal } from "@/components/Reveal";

const STATS = [
    { value: "24/7", label: "Concierge Support" },
    { value: "100%", label: "Tailor-Made Itineraries" },
    { value: "1:1", label: "Personal Travel Designer" },
    { value: "360°", label: "On-Trip Assistance" },
];

export const StatsBand = () => (
    <section className="border-y border-brass/20 bg-navy-800" data-testid="stats-band">
        <div className="mx-auto grid max-w-7xl grid-cols-2 gap-px lg:grid-cols-4">
            {STATS.map((stat, i) => (
                <Reveal key={stat.label} delay={i * 0.08} className="h-full">
                    <div className="flex h-full flex-col items-center gap-2 px-6 py-10 text-center" data-testid={`stat-${i}`}>
                        <span className="font-serif text-4xl font-semibold text-brass sm:text-5xl">{stat.value}</span>
                        <span className="text-xs font-medium uppercase tracking-[0.2em] text-ivory/60">{stat.label}</span>
                    </div>
                </Reveal>
            ))}
        </div>
    </section>
);
